<template>
    <div class="health-info">
        <div class="full-width info">
            <img src="@/assets/resource/img/health-info-bg.png" alt="" class="full-width--bg">
            <h4 class="title03">우리 몸을 치유하는 수술, 검사 정보와 병들게 하는 <span class="line-y">각종 질환 정보</span>를 검색해 보세요.</h4>
            <div class="word-search type02">
                <label class="word-search__input">
                    <input type="text" class="input" placeholder="&nbsp;" v-model="title" @keyup.enter="getList('')">
                    <div class="btn">
                        <button type="button"><img src="@/assets/resource/icon/search.svg" alt="" @click="getList('')"></button>
                    </div>
                </label>
                <kr_Consonant @consonant="searchConsonant" :list="consonantList" ref="consonant"/>
            </div>
        </div>
        <div class="health-info__box info">
            <ul class="health-info__list">
                <li class="health-info__item" v-for="article in list">
                    <a href="javascript:;" @click="$commonUtils.goArticleView(article)" v-html="article.title"></a>
                </li>
                <!-- 수정필요(퍼블리싱) -->
                <li class="health-info__item" v-if="!list && inTitle">({{inTitle}})에 대한 검색결과가 없습니다.</li>
                <li class="health-info__item" v-else-if="!list && !inTitle">검색결과가 없습니다.</li>
            </ul>
        </div>
    </div>
</template>

<script>
    import Search from '@/components/kr/common/SearchBox.vue'
    
    export default {
        components: {
            Search,
        },
        props: {
            boardInfo: ''
        },
        data() {
            return {
                board: {},
                list: '',
                pageList: '',
                // pageCount: window.innerWidth > 720 ? 10 : 5,
                pageCount: 5,
                totCnt: 0,
    
                // 게시글 parameter
                currentNum: this.$route.query.currentNum || 1,
                pageRow: 1000,
                //검색 관련 parameter
                title: this.$route.query.title || '',
                inTitle: '',
                content: this.$route.query.content || '',
                searchKeyword: this.$route.query.searchKeyword || '',
                consonant: '',

                consonantList: '',
            }
        },
        watch: {
            $route(to, from) {
                // 동일 게시판 안에서 이동
                if (to.query != from.query && to.path == from.path) {
                    const cho = this.consonant
                    if (Object.keys(to.query).length === 0) this.init()
                    if(cho) this.consonant = cho
                    for (let i in this.$route.query) {
                        this[i] = this.$route.query[i]
                    }
    
                    this.getList(this.consonant)
                }
            },
            // 다른 게시판으로 이동
            // boardInfo(oldVal, newVal) {
            //     this.init()
            //     this.getList()
            // }
        },
        methods: {
            getList(cho) {
                const boardNo = this.boardInfo.boardNo
                const params = {
                    hospId: this.$store.getters.getHost,
                    boardNo: boardNo,
                    startIndex: this.currentNum,
                    pageRow: this.pageRow,
                    title: this.title,
                    content: this.content,
                    searchKeyword: this.searchKeyword,
                }
                if(cho){
                    params.consonant = cho
                    this.consonant = cho
                }else{
                    this.consonant = ''
                }
                this.$refs.consonant.consonant = this.consonant
                this.axios.get(this.api.article.list + boardNo, {
                    params: params
                }).then(res => {
                    this.goPage()
                    this.list = res.data.list
                    this.board = res.data.board
                    this.totCnt = res.data.totCnt
                    this.inTitle = this.title
                    if(!this.consonantList){
                        this.consonantList = this.$commonUtils.setConsonantList(this.list, 'title')
                        this.consonantList.push({cho: 'AZ', disable: 'disable'})
                    }
                    if(this.list){
                        for(let i of this.list){
                            i.title = '<span>-</span>' + this.setHighlightText(i.title)
                        }
                    }
                })
            },
            searchConsonant(consonant) {
                this.init()
                this.getList(consonant)
            },
            // 검색 emit
            setState(s, v, p) {
                this[p] = ''
                this.currentNum = 1
                this[s] = v
                this.goPage()
            },
            // pagination emit
            setNum(n) {
                this.currentNum = n
                this.goPage()
            },
            goPage() {
                const obj = { title: this.title, content: this.content, searchKeyword: this.searchKeyword };
                for (const key in obj) {
                    if (obj[key] === null || obj[key] === '') {
                        delete obj[key];
                    }
                }
    
                this.$router.push({ path: this.$route.path, query: obj });
            },
            // 데이터 초기화
            init() {
                this.currentNum = 1
                this.title = ''
                this.content = ''
                this.searchKeyword = ''
                this.consonant = ''
            },
            setHighlightText(text) {
                let result = text.replace(new RegExp((this.title), 'g'), `<span class="line-y">${this.title}</span>`)
                return result
            },
        },
        mounted() {
            this.consonant = this.$route.query.consonant || 'ㄱ'
            if(this.title) {
                this.getList()
            }else{
                this.getList(this.consonant)
            }
        },
    }
    </script>
    
    <style scoped></style>